import idVerification from './idVerification'
import signAgreement from './signAgreement'
import connectPayoutAccount from './connectPayoutAccount'
import connectExpenseAccount from './connectExpenseAccount'
import updateInvoiceTemplate from './updateInvoiceTemplate'
import invitePayersToMarmalade from './invitePayersToMarmalade'
import invoiceEmailTemplate from './invoiceEmailTemplate'

export default (stepperData) => {
  const showingBankConnectionStep = stepperData?.approvedBankConnectionRequired

  const decoratedData = {
    ...stepperData,
    showingBankConnectionStep,
  }

  return [
    signAgreement(decoratedData),
    idVerification(decoratedData),
    connectPayoutAccount(decoratedData),
    connectExpenseAccount(decoratedData),
    invitePayersToMarmalade(decoratedData),
    updateInvoiceTemplate(decoratedData),
    invoiceEmailTemplate(decoratedData),
  ].filter((step) => step.visible)
}
